// extracted by mini-css-extract-plugin
module.exports = {"slider":"slick_slider__g5aWE"};